import { Notificacion, TipoNotificacion } from "@/typings/store/plugins/easyFirestore/notificaciones";

export function avisoOperacion(tipo: TipoNotificacion, titulo: string, contenido: string): Notificacion {
  return {
    tipo,
    titulo,
    contenido,
    fecha: new Date().toISOString(),
    image: null,
    curso: null,
    usuario: null,
    topico: "admins",
    enviada: false,
  };
}
